import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';

import CustomBtn from '../../../generic/CustomBtn/CustomBtn';
import Tooltip from '../../../components/Tooltip';
import './ProjectCardMenu.scss';

import {
  REGISTER_STATUS, ACTIVE_STATUS,
  SETUP_PROGRESS, ASSIGN_PROGRESS,
  UPLOAD_PROGRESS, FINISHED_PROGRESS,
  NO_PROGRESS,
} from '../../../constans/constans';

const Dots = ({ projectId }) => (
  <div
    className="card-menu__trigger"
    data-tip
    data-for={`${projectId}-menu`}
  >
    <div className="point" />
    <div className="point" />
    <div className="point" />
  </div>
);

const ProjectCardMenu = ({ isLoading, projectId, status, isStagesFinished, stageProgress, carbonApplication, isCarbon, dataOfProject }) => {
  const translate = useIntl();
  const history = useHistory();
  const [isMZPending, setIsMZPending] = useState(false);

  useEffect(() => {
    try {
      setIsMZPending(!!localStorage.getItem(`ofp_mz_pending_${projectId}`));
    } catch (e) {
      setIsMZPending(false);
    }
  }, [projectId]);

  useEffect(() => {
    if (!isLoading && stageProgress !== SETUP_PROGRESS && stageProgress !== NO_PROGRESS) {
      try {
        localStorage.removeItem(`ofp_mz_pending_${projectId}`);
      } catch (e) {
        // ignore localStorage errors
      }
      setIsMZPending(false);
    }
  }, [stageProgress, projectId, isLoading]);
  const punktCarbonOrStart = isCarbon && !dataOfProject?.leakage?.carbonApprove ? {
    label: 'projectCard.start',
    onClick: () => history.push(`/data-upload/${projectId}`),
    disabled: false,
  } : {
    label: dataOfProject?.leakage?.carbonApprove ? 'projectCard.carbonApplication.approve' : carbonApplication?.completed === false ? 'projectCard.finaliseCarbonApplication' : 'projectCard.carbonApplication',
    onClick: () => history.push(`/project/${projectId}/carbon/application`),
    disabled: false,
  };
  const menuView = [
    /*
      If the project is in register status, show View Project and
      Carbon Application/Finalise Carbon Application buttons
    */
    ...(status === REGISTER_STATUS ? [
      {
        label: 'projectCard.viewProject',
        onClick: () => history.push(`/project/${projectId}`),
        disabled: false,
      },
      punktCarbonOrStart,
    /*
      If the project is in all statuses except active or last stage was finished,
      show View Project and View Previous Report buttons
    */
    ] : status !== ACTIVE_STATUS || isStagesFinished ? [
      {
        label: 'projectCard.viewProject',
        onClick: () => history.push(`/project/${projectId}`),
        disabled: false,
      },
      {
        label: 'projectCard.viewPreviousStageReport',
        onClick: () => history.push(`/project/${projectId}/monitoring/previous-stages`),
        disabled: false,
      },
    /*
      If the project is active, show buttons depending on
      current stage step (setup zones, assign field agents etc.)
    */
    ] : [
      {
        label: 'projectCard.viewProject',
        onClick: () => history.push(`/project/${projectId}`),
        disabled: false,
      },
      ...(isMZPending && stageProgress === SETUP_PROGRESS ? [] : [{
        label: stageProgress === SETUP_PROGRESS ? 'projectCard.setupMZ' : 'projectCard.viewMZ',
        onClick: () => history.push(`/data-upload/${projectId}`),
        disabled: stageProgress >= FINISHED_PROGRESS,
      }]),
      {
        label: 'projectCard.assignFA',
        onClick: () => history.push(`/project/${projectId}/field-agents`),
        disabled: stageProgress < ASSIGN_PROGRESS || stageProgress >= FINISHED_PROGRESS,
      },
      {
        label: 'projectCard.viewPreviousStageReport',
        onClick: () => history.push(`/project/${projectId}/monitoring/previous-stages`),
        disabled: false,
      },
      {
        label: 'projectCard.prepare',
        onClick: () => history.push(`/project/${projectId}/monitoring`),
        disabled: stageProgress < UPLOAD_PROGRESS || stageProgress >= FINISHED_PROGRESS,
      },
      {
        label: dataOfProject?.leakage?.carbonApprove ? 'projectCard.carbonApplication.approve' : carbonApplication?.completed === false ? 'projectCard.finaliseCarbonApplication' : 'projectCard.carbonApplication',
        onClick: () => history.push(`/project/${projectId}/carbon/application`),
        disabled: false,
      },
    ]),
  ];

  const getMenu = () => {
    if (isLoading) {
      return (
        <span className="card-menu__loader">
          {translate.formatMessage({ id: 'projectCard.loading' })}
          ...
        </span>
      );
    }
    return menuView.map(({ onClick, label, disabled }) => (
      <CustomBtn
        label={translate.formatMessage({ id: label })}
        customClass="card-menu__button"
        handleClick={onClick}
        disabled={disabled}
        key={label}
      />
    ));
  };

  return (
    <>
      <Tooltip
        targetElement={<Dots projectId={projectId} />}
        tooltipElement={getMenu()}
        tooltipProps={{
          className: 'card-menu__body',
          id: `${projectId}-menu`,
          place: 'top',
          effect: 'solid',
          type: 'light',
          event: 'click',
          globalEventOff: 'click',
          clickable: true,
          isCapture: true,
          border: true,
          textColor: '#329d9c',
          borderColor: '#d5d9e7',
          offset: { left: 100 },
        }}
      />
    </>
  );
};

export default ProjectCardMenu;
